"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Service
 * Provides OIDC and Security endpoints as well as CRUD operations for SAVE and E-Verify Users and Points of Contact.
 *
 * The version of the OpenAPI document: 3.0.11
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTokenGrantTypeEnum = exports.AuthorizeCodeChallengeMethodEnum = exports.OIDCApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 * no description
 */
var OIDCApi = /** @class */ (function (_super) {
    __extends(OIDCApi, _super);
    function OIDCApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * https://openid.net/specs/openid-connect-core-1_0.html#AuthorizationEndpoint
     * An endpoint for receiving an Authorization Code provided user credentials
     */
    OIDCApi.prototype.authorizeRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
                            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling authorize.');
                        }
                        if (requestParameters.redirectUri === null || requestParameters.redirectUri === undefined) {
                            throw new runtime.RequiredError('redirectUri', 'Required parameter requestParameters.redirectUri was null or undefined when calling authorize.');
                        }
                        if (requestParameters.codeChallenge === null || requestParameters.codeChallenge === undefined) {
                            throw new runtime.RequiredError('codeChallenge', 'Required parameter requestParameters.codeChallenge was null or undefined when calling authorize.');
                        }
                        if (requestParameters.codeChallengeMethod === null || requestParameters.codeChallengeMethod === undefined) {
                            throw new runtime.RequiredError('codeChallengeMethod', 'Required parameter requestParameters.codeChallengeMethod was null or undefined when calling authorize.');
                        }
                        if (requestParameters.username === null || requestParameters.username === undefined) {
                            throw new runtime.RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling authorize.');
                        }
                        if (requestParameters.password === null || requestParameters.password === undefined) {
                            throw new runtime.RequiredError('password', 'Required parameter requestParameters.password was null or undefined when calling authorize.');
                        }
                        queryParameters = {};
                        if (requestParameters.clientId !== undefined) {
                            queryParameters['client_id'] = requestParameters.clientId;
                        }
                        if (requestParameters.redirectUri !== undefined) {
                            queryParameters['redirect_uri'] = requestParameters.redirectUri;
                        }
                        if (requestParameters.scope !== undefined) {
                            queryParameters['scope'] = requestParameters.scope;
                        }
                        if (requestParameters.state !== undefined) {
                            queryParameters['state'] = requestParameters.state;
                        }
                        if (requestParameters.codeChallenge !== undefined) {
                            queryParameters['code_challenge'] = requestParameters.codeChallenge;
                        }
                        if (requestParameters.codeChallengeMethod !== undefined) {
                            queryParameters['code_challenge_method'] = requestParameters.codeChallengeMethod;
                        }
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.username !== undefined) {
                            formParams.append('username', requestParameters.username);
                        }
                        if (requestParameters.password !== undefined) {
                            formParams.append('password', requestParameters.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/oidc/authorize",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AuthorizationResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * https://openid.net/specs/openid-connect-core-1_0.html#AuthorizationEndpoint
     * An endpoint for receiving an Authorization Code provided user credentials
     */
    OIDCApi.prototype.authorize = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authorizeRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * https://openid.net/specs/openid-connect-core-1_0.html#Signing
     */
    OIDCApi.prototype.getCertificationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/oidc/jwks",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * https://openid.net/specs/openid-connect-core-1_0.html#Signing
     */
    OIDCApi.prototype.getCertification = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCertificationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * https://openid.net/specs/openid-connect-core-1_0.html#TokenRequest
     */
    OIDCApi.prototype.getTokenRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.grantType === null || requestParameters.grantType === undefined) {
                            throw new runtime.RequiredError('grantType', 'Required parameter requestParameters.grantType was null or undefined when calling getToken.');
                        }
                        if (requestParameters.code === null || requestParameters.code === undefined) {
                            throw new runtime.RequiredError('code', 'Required parameter requestParameters.code was null or undefined when calling getToken.');
                        }
                        if (requestParameters.redirectUri === null || requestParameters.redirectUri === undefined) {
                            throw new runtime.RequiredError('redirectUri', 'Required parameter requestParameters.redirectUri was null or undefined when calling getToken.');
                        }
                        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
                            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling getToken.');
                        }
                        if (requestParameters.codeVerifier === null || requestParameters.codeVerifier === undefined) {
                            throw new runtime.RequiredError('codeVerifier', 'Required parameter requestParameters.codeVerifier was null or undefined when calling getToken.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.xB3TraceId !== undefined && requestParameters.xB3TraceId !== null) {
                            headerParameters['X-B3-TraceId'] = String(requestParameters.xB3TraceId);
                        }
                        if (requestParameters.xB3SpanId !== undefined && requestParameters.xB3SpanId !== null) {
                            headerParameters['X-B3-SpanId'] = String(requestParameters.xB3SpanId);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.grantType !== undefined) {
                            formParams.append('grant_type', requestParameters.grantType);
                        }
                        if (requestParameters.code !== undefined) {
                            formParams.append('code', requestParameters.code);
                        }
                        if (requestParameters.redirectUri !== undefined) {
                            formParams.append('redirect_uri', requestParameters.redirectUri);
                        }
                        if (requestParameters.clientId !== undefined) {
                            formParams.append('client_id', requestParameters.clientId);
                        }
                        if (requestParameters.codeVerifier !== undefined) {
                            formParams.append('code_verifier', requestParameters.codeVerifier);
                        }
                        if (requestParameters.scope !== undefined) {
                            formParams.append('scope', requestParameters.scope);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/oidc/token",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AccessTokenFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * https://openid.net/specs/openid-connect-core-1_0.html#TokenRequest
     */
    OIDCApi.prototype.getToken = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTokenRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return OIDCApi;
}(runtime.BaseAPI));
exports.OIDCApi = OIDCApi;
/**
    * @export
    * @enum {string}
    */
var AuthorizeCodeChallengeMethodEnum;
(function (AuthorizeCodeChallengeMethodEnum) {
    AuthorizeCodeChallengeMethodEnum["S256"] = "S256";
})(AuthorizeCodeChallengeMethodEnum = exports.AuthorizeCodeChallengeMethodEnum || (exports.AuthorizeCodeChallengeMethodEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetTokenGrantTypeEnum;
(function (GetTokenGrantTypeEnum) {
    GetTokenGrantTypeEnum["AuthorizationCode"] = "authorization_code";
})(GetTokenGrantTypeEnum = exports.GetTokenGrantTypeEnum || (exports.GetTokenGrantTypeEnum = {}));
